import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';

import { InfoModalEvent } from '@nx-ng/types';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';

@Component({
  selector: 'nx-ng-ticket-type',
  templateUrl: './ticket-result-type.component.html',
  styleUrls: ['./ticket-result-type.component.scss'],
})
export class TicketResultTypeComponent {
  @Input()
  title = '';

  @Input()
  subtitle = '';

  @Input()
  termDateTo = '';

  @Input()
  termDateFrom = '';

  @Output()
  infoClick: EventEmitter<InfoModalEvent> = new EventEmitter<InfoModalEvent>();

  constructor(@Inject(I18NEXT_SERVICE) private i18n: ITranslationService) {}

  get translatedSubtitle(): string {
    const translatedText = this.i18n.t(this.subtitle, {
      ns: 'tickets',
      replace: {
        termDateFrom: this.termDateFrom,
        termDateTo: this.termDateTo,
      },
    });

    return translatedText === this.subtitle ? '' : translatedText;
  }
  handleInfoClick(): void {
    this.infoClick.emit({
      category: 'text',
      domain: 'ticket-result-type',
      subdomain: this.title,
    });
  }
}
